import { render } from "./step4.vue?vue&type=template&id=49571880&scoped=true"
import script from "./step4.vue?vue&type=script&lang=js"
export * from "./step4.vue?vue&type=script&lang=js"

import "./step4.vue?vue&type=style&index=0&id=49571880&lang=scss&scoped=true"
import "./step4.vue?vue&type=style&index=1&id=49571880&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49571880"]])

export default __exports__